import '../../assets/css/wallet.css';
import { withRouter } from 'react-router-dom';
import { Component } from 'react';
import {
    isCurrentRoute,
    navigateTo,
    formatNumberDecimal
} from "../../lib/helper";
import { connect } from 'react-redux';
import constants from '../../lib/constants';
import { updateAppConfigAction, fetchingUserSuccess } from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import api from '../../lib/api';
import { showNotification } from '../../lib/helper';
import { useSnackbar } from "notistack";
class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            show_balance: 1,
        };

    };
    // componentDidMount() {
    //     let { is_show_balance } = this.props.memberReducer;
    //     this.setState({
    //         is_show_balance,
    //         total: this.sumWallet()
    //     });

    // }
    sumWallet = () => {
        let { real_balance, deposit_balance } = this.props.memberReducer;
        return real_balance + deposit_balance;
    }

    onNavigate = (to) => (e) => {
        navigateTo(to).bind(this)(e);
    }
    toggleShowBalance = (type) => (e) => {
        e.preventDefault();
        this.props.updateAppConfigAction({ [type]: !this.props.appReducer[type] });
    }
    onClickChangeSetting = (type) => () => {
        let { enqueueSnackbar } = this.props;
        let value = this.state[type] === 1 ? 0 : 1;
        this.setState({ [type]: value }, () => {
            api.putChangeProfile({ ['is_show_balance']: value })
                .then(({ data, success, message }) => {
                    if (success) {
                        return this.props.fetchingUserSuccess(data);
                    }
                    showNotification(enqueueSnackbar, { message, type: success ? 'success' : 'danger' });
                });
        });
    }
    render() {

        let { is_show_balance, real_balance, deposit_balance } = this.props.memberReducer;
        let { t } = this.props;
        console.log('real_balance', real_balance);
        // kiểm tra real_blance có tồn tại dấu , không
        // real_balance = Number(real_balance.replace(/,/g, ''));
        // deposit_balance = Number(deposit_balance.replace(/,/g, ''));
        let total = real_balance + deposit_balance;
        return (
            <>
                <div className='w-100 py-5  d-flex' style={{ height: '160px', backgroundImage: 'linear-gradient(#3dc99f, #2ba481)' }}>
                    <div className='container d-flex flex-column px-3'>
                        <div className='d-flex justify-content-between'>
                            <span className='' style={{ opacity: 0.5 }}>{t('TotalAssets')}</span>
                            <div className="d-flex align-items-center" style={{ cursor: 'pointer' }} onClick={this.onClickChangeSetting('is_show_balance')}>
                                <i className='fa fa-eye'></i>
                                <p className='my-0 ml-3'>{t('HideBalance')}</p>
                            </div>
                        </div>
                        <div className='d-flex align-items-center font-weight-bold mt-3 font-35'>
                            {is_show_balance == 1 && <div style={{ lineHeight: '1.5', height: '30px' }}>{formatNumberDecimal(total)}</div>}
                            {is_show_balance == 0 && <div style={{ lineHeight: '1.5', height: '30px' }}>*****</div>}
                        </div>
                    </div>
                </div>
                <div className='mx-0 py-2 mb-4 w-100' style={{ backgroundColor: 'rgb(29 35 59/ 1)' }}>
                    <div className='container w-100 d-flex flex-column px-3'>
                        <ul className='nav nav-pills'>
                            <li className='nav-item'>
                                <a data-v-c6d93ce8="" href='#' onClick={navigateTo('wallet-main').bind(this)}
                                    className={'nav-link ' + (isCurrentRoute(constants.ROUTE.WALLET_MAIN) ? 'router-link-exact-active router-link-active' : '')}>{t('MainWallet')}</a>

                            </li>
                            <li className='nav-item'>
                                <a href='#' onClick={navigateTo('wallet').bind(this)}
                                    className={'nav-link ' + (isCurrentRoute(constants.ROUTE.WALLET) ? 'router-link-exact-active router-link-active' : '')}>{t('TradeWallet')}</a>

                            </li>
                        </ul>
                    </div>
                </div>
            </>

        );
    }
}
function mapStateToProps(state) {
    return {
        memberReducer: state.memberReducer,
        appReducer: state.appReducer
    };
}
const withSnackbar = (Component) => (props) => {
    const { enqueueSnackbar } = useSnackbar();
    return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
    updateAppConfigAction,
    fetchingUserSuccess,
})(withRouter(withTranslation()(withSnackbar(Hero))));